

import React from 'react';

const Soundwave = ({ isActive = false }) => {
    return (
        <div className={`relative w-28 h-20 flex items-center justify-center ${isActive ? 'animate-pulse' : ''}`} aria-hidden="true">
            {/* Animated Sound Wave background */}
            <div className="absolute inset-0 flex items-center justify-center">
                <div className={`w-[110px] h-[50px] relative overflow-hidden mask-wave ${isActive ? 'opacity-100' : 'opacity-70'}`}>
                    {/* First wave */}
                    <svg className={`absolute top-0 left-0 w-[220px] h-[50px] animate-wave ${isActive ? 'speed-fast' : ''}`} viewBox="0 0 220 50">
                        <path stroke="#22d3ee" fill="none" strokeWidth="1.5" strokeLinecap="round" d="M0,25 C27.5,0,55,50,82.5,25 S137.5,0,165,25 S220,50,220,25" />
                    </svg>
                    {/* Second wave (inverted and offset) */}
                    <svg className={`absolute top-0 left-0 w-[220px] h-[50px] animate-wave-delay opacity-60 ${isActive ? 'speed-fast' : ''}`} viewBox="0 0 220 50">
                        <path stroke="#22d3ee" fill="none" strokeWidth="1" strokeLinecap="round" d="M0,25 C27.5,50,55,0,82.5,25 S137.5,50,165,25 S220,0,220,25" />
                    </svg>
                </div>
            </div>

            {/* Central button */}
            <div className="relative w-20 h-20 bg-gradient-to-br from-[#2C2F33] to-[#1e2022] group-hover:from-[#35383d] group-hover:to-[#25272a] group-focus-visible:ring-4 group-focus-visible:ring-cyan-400/50 transition-all duration-300 rounded-full flex items-center justify-center shadow-lg border-2 border-cyan-400/30">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8 text-cyan-400">
                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                    <line x1="12" y1="19" x2="12" y2="23" />
                    <line x1="8" y1="23" x2="16" y2="23" />
                </svg>
            </div>

            <style>
                {`
                    .mask-wave {
                        mask-image: linear-gradient(to right, transparent, black 20%, black 80%, transparent);
                        -webkit-mask-image: linear-gradient(to right, transparent, black 20%, black 80%, transparent);
                    }
                    @keyframes wave {
                        0% { transform: translateX(0); }
                        100% { transform: translateX(-110px); }
                    }
                    .speed-fast {
                        animation-duration: 2s !important;
                    }
                    .animate-wave { 
                        animation: wave 4s linear infinite;
                        transition: animation-duration 0.3s ease-out;
                    }
                    .animate-wave-delay { 
                        animation: wave 4s linear -2s infinite; 
                        transition: animation-duration 0.3s ease-out;
                    }
                    .group-hover .animate-wave,
                    .group-hover .animate-wave-delay,
                    .group-focus-visible .animate-wave,
                    .group-focus-visible .animate-wave-delay {
                        animation-duration: 2s;
                    }
                `}
            </style>
        </div>
    );
};

export default Soundwave;
